import Head from 'expo-router/head';
import { useTranslation } from 'react-i18next';

import { NavLink } from './nav-link';
import { Page } from './page';
import { localePath } from '../lib/format';
import { useLocale } from '@todo/core/i18n/use-locale';
import { SITE_NAME } from '@todo/core/seo';

import css from './not-found-screen.module.css';

// Exported as +not-found.html; packages/web-build's 404 step copies it to
// 404.html, which the Worker serves with a 404 status for any unknown URL.
export function NotFoundScreen() {
  const { t } = useTranslation();
  const { locale } = useLocale();

  return (
    <Page>
      <Head>
        <title>{`${t('notFound.title')} — ${SITE_NAME}`}</title>
        <meta name="robots" content="noindex, follow" />
      </Head>
      <div className={css.box}>
        <h1 className={css.title}>{t('notFound.title')}</h1>
        <p className={css.text}>{t('notFound.text')}</p>
        <NavLink href={localePath(locale)} className={css.button}>
          {t('notFound.home')}
        </NavLink>
      </div>
    </Page>
  );
}
